/* tslint:disable */
import { Step } from "./Step"
import { Text } from "./Text"

export class Form {
		Guid: string;
		Organisation: string;
		DataType: string;
		FormState: string;
		ShowSummary: boolean;
		Id: number;
		Name: string;
		Description: string;

		Steps: Step[];
		Texts: Text[];
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Form.ts